
















































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Components
import Box from '@/components/common/Box.vue'
import ModalWrapper from '@/components/common/ModalWrapper.vue'

@Component({
  components: {
    Box,
    ModalWrapper
  }
})
export default class CostingTeaser extends Vue {
  showModale = false
  mode = null

  @Getter('locale', { namespace: 'user' }) locale

  get selectedOptionTitle() {
    return this.$t(`teaser.${this.mode}.title`)
  }

  get selectedOptionDescription() {
    return this.$t(`teaser.${this.mode}.description`)
  }

  get selectedOptionLines() {
    return [
      this.$t(`teaser.${this.mode}.line1`),
      this.$t(`teaser.${this.mode}.line2`),
      this.$t(`teaser.${this.mode}.line3`)
    ]
  }

  updateModale(mode) {
    this.mode = mode
    this.showModale = true
  }

  get teaserLink() {
    return this.locale === 'fr'
      ? 'https://zfrmz.com/bMTzIbjFXQGXFxWbc7IR'
      : 'https://zfrmz.com/0OOQwWfm3cBrAw6ujcWR'
  }
}
